<div class="flex-col place-content-center place-items-center w-full">
  <div id="no-appointments"
    class="flex flex-col place-content-center place-items-center search-results-container my-16">
    <mat-icon class="h-80 w-80" color="no-results-icon" svgIcon="tech_2"></mat-icon>
    <!-- <span class="mat-small">Welcome to the technician portal. Enter a work order ID to access and complete the vehicle
      inspection.</span> -->
  </div>
  <form class="flex flex-col" id="workOrderForm" [formGroup]="workOrderForm">
    <div class="flex flex-row justify-center">
      <div class="form-field" class="pt-5">
        <mat-form-field appearance="outline">
          <mat-label>Work Order Lookup</mat-label>
          <input matInput name="fromDate" formControlName="workOrderId" placeholder="Work Order ID" type="number">
          <mat-error *ngIf=" workOrderForm.get('workOrderId').errors">
            {{workOrderForm.get('workOrderId').errors | inputError}}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="focus:ring-0 flex place-content-start place-items-center pt-.5 ml-.5">
        <button mat-mini-fab color="primary" class="focus:ring-0 ml-3" (click)="search(workOrderForm.value)"
          [disabled]="workOrderForm.invalid">
          <span *ngIf="!(searchLoading$ | async); else loading">
            <mat-icon>search</mat-icon>
          </span>
          <ng-template #loading>
            <div class="flex flex-row justify-center items-center mt-1">
              <div style="border-top-color: transparent !important;"
                class="border-solid animate-spin rounded-full border-grey-200 border-2 h-4 w-4 opacity-70"></div>
            </div>
          </ng-template>
        </button>
      </div>
    </div>
    <!-- <div fxLayout="row" fxLayoutAlign="center center" class="button-container">
      <button id="apply-filters-button" type="button" mat-raised-button color="primary">Apply</button>
    </div> -->
  </form>
</div>